import { useState } from "react";

/**
 * Meyar wordmark. Blue "m" + black/white "eyar" (product brand).
 *   variant="colour"   → colour PNG for light backgrounds
 *   variant="knockout" → "m" blue + "eyar" white, for dark backgrounds
 */
export function MeyarLogo({ variant = "colour", className = "" }) {
  const [failed, setFailed] = useState(false);
  const src = variant === "knockout" ? "/assets/meyar-logo-white.png" : "/assets/meyar-logo.png";
  const sizing = className && /(^|\s)h-/.test(className) ? className : `h-8 md:h-10 ${className}`;
  if (!failed) {
    return (
      <img
        src={src}
        alt="Meyar"
        onError={() => setFailed(true)}
        data-testid="meyar-logo"
        className={`w-auto ${sizing}`}
      />
    );
  }
  const eyarColor = variant === "knockout" ? "text-white" : "text-wafa-deep";
  return (
    <span data-testid="meyar-logo" aria-label="Meyar" className={`inline-flex items-baseline font-heading text-2xl font-semibold leading-none ${className}`}>
      <span style={{ color: "#0056FF" }}>m</span>
      <span className={eyarColor}>eyar</span>
    </span>
  );
}
